import moment from 'moment';

angular.module('magpieLineage', [
  'ui.bootstrap',
  'magpieUtil'
]).
directive('magpieGenericLineage', function() {
  return {
    restrict: 'E',
    scope: {
      lineage: '='
    },
    templateUrl: 'components/magpie-display/lineage/lineage.html'
  };
}).
directive('magpieLineageActionDetails', function() {
  return {
    restrict: 'E',
    scope: {
      lineageActions: '='
    },
    templateUrl: 'components/magpie-display/lineage/lineage-action-details.html'
  };
}).
directive('magpieLineageActionRecord', function() {
  return {
    restrict: 'AE',
    scope: {
      record: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/lineage/lineage-action-record.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      _.defaults($scope.record, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/lineage/magpie-lineage.js